import { HumanCaneIcon } from './HumanCaneIcon';

/**
 * author: Google
 * id 40DD914F-1089-4A7B-AA3D-630C643E8FFF
 * name human-cane
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-cane.svg
 * tags
 * - Medical / Hospital 
 * - People / Family 
 */
export const ElderlyIcon = HumanCaneIcon;
export default ElderlyIcon